import Column from '@components/Column';
import Divider from '@components/Divider';
import Text from '@components/Text';
import colors from '@constants/colors';
import { EventResponse } from '@models/event';
import dayjs from 'dayjs';

import styles from './styles.module.scss';

interface Props {
    event: EventResponse;
}

function EventHeader({ event }:Props) {
  const { title, startAt, endAt } = event;
  const eventDuration = `${dayjs(startAt).format('YYYY.MM.DD')} - ${dayjs(endAt).format('YYYY.MM.DD')}`;
  return (
        <Column as='section' className={styles.container}
                fullWidth
                spacing={16}>
            <Text size='2xl' fontWeight='bold' className={styles.title}>{title}</Text>
            <Text color={colors.gray6}>{eventDuration}</Text>
            <Divider isThin />
        </Column>
  );
}

export default EventHeader;
